export const RESTO_BRAND_ID = 121

export enum Divisions {
    GC = '01',
    LUXE = '02',
}